import React, { PureComponent } from 'react'

export class FolhaManual extends PureComponent {
  render() {
    return (
      <div>FolhaManual</div>
    )
  }
}

export default FolhaManual